
import { defineComponent } from "vue";
import CalenderInput from "@/views/shared/form-parts/CalenderInput.vue";
import Utility from "@/assets/common/scripts/utility";
import { string } from "yup";
import { validationMessages as message } from "@/assets/validation/validation-messages";
import { useOrderStore } from "@/stores/order";

const MIN_ORDER_DAYS_FROM_CURRENT_DAY = 2;
const MIN_INTERVAL_DAYS = 2;

export default defineComponent({
  name: "TravelTerm",
  components: {
    CalenderInput,
  },
  props: {
    departureDate: {
      type: [String, Date],
      required: true,
    },
    arrivalDate: {
      type: [String, Date],
      required: true,
    },
  },
  watch: {
    departureDate: function (newVal, oldVal) {
      const newDate: Date = new Date(newVal);
      const arrDate: Date = new Date(this.arrivalDate);
      const bufferTime = MIN_INTERVAL_DAYS * 24 * 60 * 60 * 1000;
      const newDate2 = new Date(newDate.getTime() + bufferTime);
      const newVal2 =
        newDate2.getFullYear() +
        "-" +
        String(newDate2.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(newDate2.getDate()).padStart(2, "0");
      if (oldVal === "" || newDate > arrDate || newDate2 > arrDate) {
        this.$emit("update:arrivalDate", newVal2);
      }
    },
  },
  data() {
    return {
      validRules: {
        departureDate: string().required(message.required),
        arrivalDate: string().required(message.required),
      },
    };
  },
  computed: {
    currentTime(): Date {
      return useOrderStore().currentTime;
    },
    minOrderDate(): Date {
      const bufferTime = MIN_ORDER_DAYS_FROM_CURRENT_DAY * 24 * 60 * 60 * 1000;
      return new Date(this.currentTime.getTime() + bufferTime);
    },
    minArrivalDate(): Date {
      const bufferTime = MIN_INTERVAL_DAYS * 24 * 60 * 60 * 1000;
      return new Date(new Date(this.departureDate).getTime() + bufferTime);
    },
    travelingDays(): string {
      if (!this.departureDate || !this.arrivalDate) return "ー";
      return Utility.calculateTravelingDays(
        this.departureDate,
        this.arrivalDate
      );
    },
  },
  methods: {
    onUpdateDepartureDate(modelData: string): void {
      this.$emit("update:departureDate", modelData);
    },
    onUpdateArrivalDate(modelData: string): void {
      this.$emit("update:arrivalDate", modelData);
    },
  },
  emits: ["update:departureDate", "update:arrivalDate"],
});
